export default __webpack_public_path__ + "static/media/pictogramBeaconTrauma48.9840ea74.svg";